'use client';

import HeaderContext from '@/context/HeaderContext';
import { PropsWithChildren, useEffect, useState } from 'react';

const HeaderProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [height, setHeight] = useState(0);
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);
  const [isCartOpened, setIsCardOpened] = useState<boolean>(false);
  const [isSearchOpened, setIsSearchOpened] = useState<boolean>(false);

  useEffect(() => {
    const element = document.getElementById('header') as HTMLInputElement;
    if (element) setHeight(element.clientHeight);
  });

  useEffect(() => {
    if (isMenuOpened) {
      setIsCardOpened(false);
      setIsSearchOpened(false);
    }
  }, [isMenuOpened]);

  useEffect(() => {
    if (isSearchOpened) {
      setIsCardOpened(false);
      setIsMenuOpened(false);
    }
  }, [isSearchOpened]);

  useEffect(() => {
    if (isCartOpened) {
      setIsMenuOpened(false);
      setIsSearchOpened(false);
    }
  }, [isCartOpened]);

  return (
    <HeaderContext.Provider
      value={{
        height,
        isMenuOpened,
        isCartOpened,
        isSearchOpened,
        setIsMenuOpened,
        setIsCardOpened,
        setIsSearchOpened,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export default HeaderProvider;
